// extracted by mini-css-extract-plugin
module.exports = {"section":"article_section__N2WmD","hide":"article_hide__9mpFT"};